export default "__VITE_ASSET__CAKNicVV__"